import { setSnackState } from '../../../../actions';
import { notificationDispatchUtil } from '../../../../utils/dispatchUtil';
import i18n from '../../../../i18n';

export const authenticatorAppSnackUtil = {
  authenticatorAppAlreadyEnabled: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('authenticatorApp:authenticatorAppAlreadyEnabled'),
      }),
    );
  },
  authenticatorAppSetupNotStarted: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('authenticatorApp:authenticatorAppSetupNotStarted'),
      }),
    );
  },
  authenticatorAppCodeInvalid: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('authenticatorApp:authenticatorAppCodeInvalid'),
      }),
    );
  },
  authenticatorAppNotEnabled: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('authenticatorApp:authenticatorAppNotEnabled'),
      }),
    );
  },
  codeCopied: () => {
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: i18n.t('authenticatorApp:codeCopied'),
        severity: 'success',
        duration: 1500,
      }),
    );
  },
};
